import React from 'react'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Text } from 'blaze-ui/Text/Text'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { getProviderTacticsAndPlatforms, integrationIsInBrandPlan } from '../utils'
import Styles from './TacticIntegration.module.scss'

export const NoContentInBrandPlan = ({ integration }: { integration: ExternalIntegration }) => {
  const { data: brandPlan } = useCurrentBrandPlan()

  if (
    integrationIsInBrandPlan(integration, brandPlan) &&
    getProviderTacticsAndPlatforms(integration.provider).tactics.length > 0
  ) {
    return <></>
  }
  return (
    <div className={Styles.notInBrandPlan}>
      <Text variant="metadata" color="var(--dark-80)">
        No content in Content Plan
      </Text>
    </div>
  )
}
